import { useRef, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import InputAddressPanel from '../InputAddressPanel/InputAddressPanel.jsx';
import { useCustomer } from '../../../Providers/CustomerProvider.jsx';
import { useAuth } from '../../../Providers/AuthProvider.jsx';
import LoadingSpinner from '../../Components/LoadingSpinner.jsx';
import useCheckUserRole from '../../BasketPage/Hooks/useCheckUserRole.ts';
import { UserRole } from '../../../Data/UserRolesEnum.ts';
import { validateZipCode, validateInternationalPhone, validateEmail } from '../../../Helpers/ValidatorHelper.jsx';
import { capitalizeFirstLetter } from '../../../Helpers/CustomConverter.jsx';

const AddEditDeliveryAddress = ({ handlingAddress, setHandlingAddress, isChangeAddressVisible, setisChangeAddressVisible, setNewAddedAddressRecNo, fromMainDeliveryCard = false }) => {
    const { t } = useTranslation();
    const { authState } = useAuth();
    const { addDeliveryAddress, handleGetDeliveryAddresses, updateDeliveryAddress, setAddress, setDeliveryAddressAsMain } = useCustomer()
    const [isLoading, setIsLoading] = useState(false)
    const [error, setError] = useState('')
    const { isUserHasAccess } = useCheckUserRole()
    const dateToRef = useRef(null)

    const handleEditAddress = (e) => {
        const { name, value } = e.target;
        setError('')
        if (name == 'name' || name == 'street' || name == 'city') {
            const capitalizeValue = capitalizeFirstLetter(value)
            setHandlingAddress({
                ...handlingAddress,
                [name]: capitalizeValue
            })
        } else {
            setHandlingAddress({
                ...handlingAddress,
                [name]: value
            })
        }

    }

    const handleCancelButtonClick = () => {
        setHandlingAddress({ name: '', street: '', zipCode: '', city: '', email: '', phone: '', recNo: 0, isExpAddress: false, expirationDate: '' })
        setisChangeAddressVisible(false);
    }

    const handleChangeAddressType = () => {
        if (handlingAddress.isExpAddress) {
            if (dateToRef.current) {
                dateToRef.current.instance.reset();
            }
            setHandlingAddress({
                ...handlingAddress,
                isExpAddress: !handlingAddress.isExpAddress,
                expirationDate: ''
            })
        } else {
            setHandlingAddress({
                ...handlingAddress,
                isExpAddress: !handlingAddress.isExpAddress
            })
        }
    }

    const DateToOnValueChanged = (e) => {
        if (e.value) {
            const selectedDate = e.value.toLocaleString('en-CA').substring(0, 10);
            setHandlingAddress({
                ...handlingAddress,
                expirationDate: selectedDate
            })
        }
    }

    const handleAddEditAddress = async () => {
        if (!handlingAddress.name) {
            setError("Podaj nazwę!")
            return;
        } else if (!handlingAddress.street) {
            setError("Podaj ulicę!")
            return;
        } else if (!handlingAddress.zipCode) {
            setError("Podaj kod pocztowy!")
            return;
        } else if (!validateZipCode(handlingAddress.zipCode)) {
            setError("Podaj prawidłowy kod pocztowy!")
            return;
        } else if (!handlingAddress.city) {
            setError("Podaj miejscowość!")
            return;
        } else if (handlingAddress.email && !validateEmail(handlingAddress.email)) {
            setError("Podaj prawidłowy adres e-mail!")
            return;
        } else if (!handlingAddress.phone) {
            setError("Podaj numer telefonu!")
            return;
        } else if (!validateInternationalPhone(handlingAddress.phone)) {
            setError("Podaj prawidłowy numer telefonu!")
            return;
        } else if (handlingAddress.isExpAddress && !handlingAddress.expirationDate) {
            setError("Podaj termin ważności adresu lub przełącz na bezterminowy!")
            return;
        }
        setIsLoading(true)
        var result = true
        if (isUserHasAccess(UserRole.Admin)) {
            if (handlingAddress.recNo > 0) {
                result = await updateDeliveryAddress(authState.custId, handlingAddress.name, handlingAddress.zipCode, handlingAddress.city, handlingAddress.street, handlingAddress.phone, handlingAddress.email, handlingAddress.expirationDate, handlingAddress.recNo)
            } else {
                result = await addDeliveryAddress(authState.custId, handlingAddress.name, handlingAddress.zipCode, handlingAddress.city, handlingAddress.street, handlingAddress.phone, handlingAddress.email, handlingAddress.expirationDate)
                if (setNewAddedAddressRecNo) {
                    setNewAddedAddressRecNo(result)
                }
                if (fromMainDeliveryCard) {
                    await setDeliveryAddressAsMain(result)
                }
            }
        }
        setIsLoading(false)
        if (result) {
            if (isUserHasAccess(UserRole.Admin)) {
                handleGetDeliveryAddresses(false)
                handleGetDeliveryAddresses(true)
            }
            else { //gdy nie mamy admina dodajemy tylko kontekstowo do danego zamówienia
                var newTmpAddress = {
                    city: handlingAddress.city,
                    effectiveDate: handlingAddress.handlingAddress,
                    email: handlingAddress.email,
                    id: '999999',
                    mainDeliveryAddress: false,
                    name: handlingAddress.name,
                    phoneNumber: handlingAddress.phone,
                    recNo: '0',
                    street: handlingAddress.street,
                    zipCode: handlingAddress.zipCode,
                }
                setAddress(prev => [
                    ...prev.filter(a => a.id !== '999999'),
                    newTmpAddress
                ])
                if (setNewAddedAddressRecNo) {
                    setNewAddedAddressRecNo('0')
                }
            }
            setHandlingAddress({ name: '', street: '', zipCode: '', city: '', email: '', phone: '', recNo: 0, isExpAddress: false, expirationDate: '' })
            setisChangeAddressVisible(false);
        } else {
            setError("Błąd podczas zapisu adresu!")
        }
    }

    if (!isUserHasAccess(UserRole.Admin) && handlingAddress.recNo > 0) {
        return <Modal size='lg' show={isChangeAddressVisible} onHide={handleCancelButtonClick} centered>
            <Modal.Header closeButton>
                <Modal.Title>Brak uprawnień do edycji adresu!</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className='d-flex flex-column' style={{ fontSize: '1.3rem' }}>
                    <span className='error-text-color'>Brak uprawnień!</span>
                    <span className='error-text-color'>Skontaktuj się z administratorem strony</span>
                </div>
            </Modal.Body>
        </Modal>
    }
    return <>
        <Modal size='lg' show={isChangeAddressVisible} onHide={handleCancelButtonClick} centered>
            <Modal.Header closeButton>
                <Modal.Title>{t("address_table_header_orders_page")}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {isLoading ? (<LoadingSpinner />) : (<><InputAddressPanel address={handlingAddress} handleEditAddress={handleEditAddress} handleAddEditAddress={handleAddEditAddress} title={t("confirm")} handleChangeAddressType={handleChangeAddressType} DateToOnValueChanged={DateToOnValueChanged} dateToRef={dateToRef} />
                    {error.length > 0 ? (<div className="row error-text-color justify-content-center mb-4">{error}</div>) : (<></>)}</>)}
            </Modal.Body>
        </Modal>
    </>
}
export default AddEditDeliveryAddress; 